enum EView {
    
    OUTTER = 1,
    INNER = 2,
    META_DATA = 4
    
}

export default EView;
